import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface TransmissionTypeDTO extends BaseIntDTO {
  transmissionTypeName: string;
}
